import { useLiveTrigger, useResponsiveValue } from '@lemonade-hq/cdk';
import type React from 'react';

interface LiveLerpTriggerProps {
  t: number;
  trigger: number | [number] | [number, number] | [number, number, number];
  onTrigger?: ((value: boolean) => unknown) | undefined;
}

export const LiveLerpTrigger: React.FC<React.PropsWithChildren<LiveLerpTriggerProps>> = ({
  t,
  trigger,
  onTrigger,
  children,
}) => {
  const actualTriggerValue = useResponsiveValue(trigger);

  useLiveTrigger({
    trigger: () => {
      return t >= actualTriggerValue;
    },
    onTrigger,
  });

  return <>{children}</>;
};
